(function () {
  "use strict";
  var L = window.Lagom || {},
    q =
      L.q ||
      function (s, r) {
        return (r || document).querySelector(s);
      },
    qa =
      L.qa ||
      function (s, r) {
        return Array.prototype.slice.call((r || document).querySelectorAll(s));
      },
    C = L.config || {},
    routes = C.routes || {},
    panel = q("[data-cart-panel]"),
    scrim = q("[data-cart-scrim]"),
    toggles = qa("[data-cart-toggle], [data-cart-link]"),
    header = q("[data-header]");
  if (!panel) return;
  var SECTION = "cart-drawer",
    timer = 0, opening = false, openingId = 0, layoutFrame = 0,
    contentsReady = Promise.resolve(), returnFocus = null;
  function motionOff() {
    return L.motionOff ? L.motionOff() : !1;
  }
  function isOpen() {
    return (
      panel.classList.contains("is-open") &&
      !panel.classList.contains("is-closing")
    );
  }
  function expanded(open) {
    toggles.forEach(function (t) {
      t.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }
  function resetScroll() {
    panel.scrollTop = 0;
    qa("[data-cart-inner], [data-cart-items]", panel).forEach(function (el) {
      el.scrollTop = 0;
    });
  }
  function position() {
    var viewport = window.visualViewport,
      top = viewport ? viewport.offsetTop : 0,
      height = viewport ? viewport.height : window.innerHeight,
      mobile = window.matchMedia("(max-width: 767px)").matches,
      bar = header && q(".header__inner", header),
      panelTop = mobile && bar ? Math.max(top + 12, bar.getBoundingClientRect().bottom + 12) : top + 12;
    panel.style.top = Math.round(panelTop) + "px";
    panel.style.setProperty("--cart-available-height", Math.max(0, height - (panelTop - top) - 12) + "px");
    if (scrim) {
      scrim.style.top = top + "px";
      scrim.style.height = height + "px";
      scrim.style.bottom = "auto";
    }
  }
  function queuePosition() {
    if ((!isOpen() && !opening) || layoutFrame) return;
    layoutFrame = window.requestAnimationFrame(function () {
      layoutFrame = 0;
      if (isOpen() || opening) position();
    });
  }
  // Every entry point awaits the same content update, then lays out the hidden
  // panel before revealing it. A frame boundary replaces timing guesses.
  function openCart() {
    var id = ++openingId;
    opening = true;
    window.clearTimeout(timer);
    return contentsReady.then(function () {
      if (id !== openingId) return;
      document.dispatchEvent(new CustomEvent("lagom:panel", { detail: "cart" }));
      var wasOpen = isOpen();
      if (!wasOpen) returnFocus = document.activeElement;
      L.lock.lock("cart", true);
      document.documentElement.classList.add("is-cart-open");
      header && header.classList.add("is-panel-open");
      if (!wasOpen) panel.classList.remove("is-settled");
      panel.classList.remove("is-closing");
      if (!wasOpen) panel.classList.add("is-preparing");
      return new Promise(function (resolve) {
        window.requestAnimationFrame(function () {
          if (id !== openingId) { resolve(); return; }
          position();
          resetScroll();
          panel.classList.add("is-open");
          panel.classList.remove("is-preparing");
          if (motionOff()) panel.classList.add("is-settled");
          scrim && scrim.classList.add("is-on");
          opening = false;
          expanded(true);
          // Focus the small, visible close control, not the entire scrollable
          // dialog (Safari may try to bring the whole dialog into view).
          var close = q("button[data-cart-close]", panel);
          if (close) close.focus({ preventScroll: true });
          resetScroll();
          tick();
          resolve();
        });
      });
    });
  }
  function closeCart() {
    ++openingId;
    opening = false;
    window.clearTimeout(timer);
    panel.classList.remove("is-preparing");
    scrim && scrim.classList.remove("is-on");
    // Restore focus while the page is still frozen; neither path scrolls it.
    if (panel.contains(document.activeElement) && returnFocus && returnFocus.isConnected)
      returnFocus.focus({ preventScroll: true });
    returnFocus = null;
    document.documentElement.classList.remove("is-cart-open");
    L.lock.unlock("cart");
    header && header.classList.remove("is-panel-open");
    if (panel.classList.contains("is-open") && !motionOff()) {
      panel.classList.add("is-closing");
      timer = window.setTimeout(function () {
        panel.classList.remove("is-open", "is-closing");
      }, 300);
    } else panel.classList.remove("is-open", "is-closing");
    expanded(false);
  }
  function apply(html) {
    if (html) {
      var doc = new DOMParser().parseFromString(html, "text/html"),
        fresh = doc.querySelector("[data-cart-inner]"),
        cur = q("[data-cart-inner]", panel);
      if (!(!fresh || !cur)) {
        cur.innerHTML = fresh.innerHTML;
        var status = q("[data-cart-status]", panel);
        if (status) status.textContent = "";
        cur.setAttribute("data-cart-count-value",fresh.getAttribute("data-cart-count-value"));
        var n = parseInt(fresh.getAttribute("data-cart-count-value"), 10);
        (!isNaN(n) && L.cart && L.cart.setCount && L.cart.setCount(n), tick());
      }
    }
  }
  function refresh(strict) {
    return fetch((routes.root || "/") + "?sections=" + SECTION, {
      headers: { Accept: "application/json" },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (d) {
        if (strict && !d[SECTION]) throw new Error("Cart section unavailable");
        apply(d[SECTION]);
      })
      .catch(function (error) { if (strict) throw error; });
  }
  function addUpsell(form) {
    if (panel.classList.contains("is-busy")) return;
    var variant = q('[name="id"]', form),
      button = q('[type="submit"]', form),
      label = q("[data-upsell-button-text]", form),
      errorBox = q("[data-upsell-error]", form),
      status = q("[data-cart-status]", panel),
      originalLabel = label.textContent,
      added = false;
    panel.classList.add("is-busy");
    form.setAttribute("aria-busy", "true");
    button.disabled = true;
    label.textContent = form.getAttribute("data-adding");
    errorBox.hidden = true;
    if (status) status.textContent = "";
    fetch((routes.cartAdd || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variant.value), quantity: 1 }], sections: SECTION, sections_url: routes.root || "/" }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || form.getAttribute("data-error"));
          added = true;
          // Prices, discounts and the checkout amount all come from Shopify's
          // newly rendered cart section, never from the upsell's displayed price.
          if (data.sections && data.sections[SECTION]) apply(data.sections[SECTION]);
          else return refresh(true);
        });
      })
      .then(function () {
        if (status) status.textContent = form.getAttribute("data-added");
        if (isOpen()) {
          resetScroll();
          q("button[data-cart-close]", panel).focus({ preventScroll: true });
          queuePosition();
        }
      })
      .catch(function (error) {
        errorBox.textContent = added ? form.getAttribute("data-refresh-error") : error.message || form.getAttribute("data-error");
        errorBox.hidden = false;
        if (added && status) status.textContent = errorBox.textContent;
      })
      .then(function () {
        panel.classList.remove("is-busy");
        form.removeAttribute("aria-busy");
        // If Shopify added the item but refresh failed, do not offer a retry
        // that could add it twice. A page reload safely restores the real cart.
        button.disabled = added;
        label.textContent = originalLabel;
      });
  }
  function change(line, qty) {
    (panel.classList.add("is-busy"),
      fetch((routes.cartChange || "/cart/change") + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ line: line, quantity: qty, sections: SECTION }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (cart && cart.sections && cart.sections[SECTION])
            apply(cart.sections[SECTION]);
          else return refresh();
        })
        .catch(function () {
          return refresh();
        })
        .then(function () {
          panel.classList.remove("is-busy");
        }));
  }
  var RESERVE_MS = 600 * 1e3,
    RKEY = "lagom-cart-reserved",
    rTimer = 0,
    rLast = "";
  function store(get, val) {
    try {
      if (get) return window.sessionStorage.getItem(RKEY);
      val === null
        ? window.sessionStorage.removeItem(RKEY)
        : window.sessionStorage.setItem(RKEY, String(val));
    } catch (e) {}
    return null;
  }
  function count() {
    var inner = q("[data-cart-inner]", panel);
    return (
      (inner && parseInt(inner.getAttribute("data-cart-count-value"), 10)) || 0
    );
  }
  function reserve() {
    (store(!1, Date.now() + RESERVE_MS), (rLast = ""), tick());
  }
  function tick() {
    window.clearTimeout(rTimer);
    var box = q("[data-cart-reserved]", panel),
      out = box && q("[data-cart-timer]", box);
    if (box) {
      var until = parseInt(store(!0), 10) || 0,
        left = until - Date.now();
      if (
        (count() > 0 &&
          left <= 0 &&
          ((until = Date.now() + RESERVE_MS),
          store(!1, until),
          (left = RESERVE_MS)),
        count() === 0 && (store(!1, null), (left = 0)),
        left <= 0)
      ) {
        (box.hidden || (box.hidden = !0), (rLast = ""));
        return;
      }
      var sec = Math.ceil(left / 1e3),
        txt = Math.floor(sec / 60) + ":" + ("0" + (sec % 60)).slice(-2);
      (txt !== rLast && ((out.textContent = txt), (rLast = txt)),
        box.hidden && (box.hidden = !1),
        panel.classList.contains("is-open") &&
          (rTimer = window.setTimeout(tick, 1e3 - (left % 1e3) + 20)));
    }
  }
  panel.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-cart-upsell]");
    if (!form) return;
    e.preventDefault();
    addUpsell(form);
  });
  panel.addEventListener("change", function (e) {
    if (!e.target.matches("[data-upsell-variant]")) return;
    var option = e.target.selectedOptions[0], form = e.target.closest("[data-cart-upsell]"), image = q(".cart-upsell__image img", form);
    q("[data-upsell-price]", form).textContent = option.getAttribute("data-price");
    if (image && option.getAttribute("data-image")) {
      image.removeAttribute("srcset");
      image.src = option.getAttribute("data-image");
    }
  });
  (toggles.forEach(function (t) {
    (t.setAttribute("aria-controls", "cart-panel"),
      t.setAttribute("aria-expanded", "false"),
      t.addEventListener("click", function (e) {
        (e.preventDefault(), e.stopPropagation(), isOpen() || opening ? closeCart() : openCart());
      }));
  }),
    panel.addEventListener("animationend", function (e) {
      if (e.target === panel && isOpen() && /^(cart-unroll|cart-in)$/.test(e.animationName))
        panel.classList.add("is-settled");
    }),
    panel.addEventListener("click", function (e) {
      e.stopPropagation();
      var b = e.target.closest("[data-qty]"),
        r = e.target.closest("[data-remove]"),
        li = e.target.closest("[data-line]");
      if (b && li) {
        var cur = parseInt((q("[aria-live]", li) || {}).textContent, 10) || 0;
        change(
          parseInt(li.getAttribute("data-line"), 10),
          Math.max(0, cur + parseInt(b.getAttribute("data-qty"), 10)),
        );
        return;
      }
      if (r && li) {
        change(parseInt(li.getAttribute("data-line"), 10), 0);
        return;
      }
      e.target.closest("[data-cart-close]") && closeCart();
    }),
    scrim &&
      scrim.addEventListener("click", function () {
        closeCart();
      }),
    document.addEventListener("keydown", function (e) {
      e.key === "Escape" &&
        (isOpen() || opening) && closeCart();
    }),
    document.addEventListener("lagom:panel", function (e) {
      e.detail !== "cart" && (isOpen() || opening) && closeCart();
    }),
    document.addEventListener("lagom:cart", function (e) {
      var cart = e.detail || {};
      if (cart.silent) {
        cart.sections &&
          cart.sections[SECTION] &&
          apply(cart.sections[SECTION]);
        return;
      }
      reserve();
      contentsReady = contentsReady.then(function () {
        if (cart.sections && cart.sections[SECTION]) apply(cart.sections[SECTION]);
        else return refresh();
      });
      openCart();
    }),
    document.addEventListener("lagom:cart:open", function () {
      openCart();
    }),
    qa("[data-toast-link]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        (e.preventDefault(), openCart());
      });
    }),
    window.addEventListener("pageshow", function (e) {
      e.persisted && refresh();
    }),
    window.addEventListener("resize", queuePosition),
    window.visualViewport && window.visualViewport.addEventListener("resize", queuePosition),
    window.visualViewport && window.visualViewport.addEventListener("scroll", queuePosition),
    tick());
})();

